import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { AppRouter } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { LanguageProvider } from './contexts/LanguageContext';
import { BannerProvider } from './contexts/BannerContext';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './theme/ThemeProvider';
import { CheckoutProvider } from './contexts/CheckoutContext';
import { HelmetProvider } from 'react-helmet-async';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <CssBaseline />
          <Box sx={{ 
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <LanguageProvider>
              <AuthProvider>
                <CheckoutProvider>
                  <BannerProvider>
                    <AppRouter />
                  </BannerProvider>
                </CheckoutProvider>
              </AuthProvider>
            </LanguageProvider>
          </Box>
        </ThemeProvider>
      </I18nextProvider>
    </HelmetProvider>
  );
};

export default App;
